import React, { FC, MouseEvent, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { Text } from '@shared/ui/atoms';
import { withTheme } from '@shared/lib/theme';
import { CheckIcon } from '@shared/assets/icons';
export interface SelectOption {
  icon?: ReactNode;
  label: string;
  value: string;
}
interface OptionProps {
  isSelected: boolean;
  option: SelectOption;
  onSelect: (value: SelectOption) => void;
}
const Option: FC<OptionProps> = ({
  isSelected,
  option,
  onSelect
}) => {
  const handleSelect = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onSelect(option);
  };
  console.log(option);
  return <OptionWrapper type="button" isSelected={isSelected} onClick={handleSelect}>
      <LeftContentWrapper>
        {option.icon && <IconWrapper>{option.icon}</IconWrapper>}
        <Text family="MTSCompact" size="pL" weight="medium" color="primary">
          {option.label}
        </Text>
      </LeftContentWrapper>
      {isSelected && <RightContentWrapper>
          <CheckIcon />
        </RightContentWrapper>}
    </OptionWrapper>;
};
export default Option;
type OptionWrapperProps = Required<Pick<OptionProps, 'isSelected'>>;
const _exp = /*#__PURE__*/() => ({
  isSelected
}) => isSelected ? 'space-between' : 'flex-start';
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.hover;
const OptionWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "OptionWrapper",
  class: "oybfet2",
  propsAsIs: false,
  vars: {
    "oybfet2-0": [_exp()],
    "oybfet2-1": [_exp3()]
  }
}));
const LeftContentWrapper = /*#__PURE__*/styled('div')({
  name: "LeftContentWrapper",
  class: "l19maxic",
  propsAsIs: false
});
const RightContentWrapper = /*#__PURE__*/styled('div')({
  name: "RightContentWrapper",
  class: "r1jihe89",
  propsAsIs: false
});
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1bx0cx3",
  propsAsIs: false
});

require("./Option.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Option.tsx");